import { Link } from 'react-router-dom';
import { TableCardProps } from '@/components/Tables/TableCard/TableCard.types';

import styles from './BundleUpchargesTable.module.css';

export const BundleUpchargeTableTitle = <TData extends object>({ breadcrumb, title }: TableCardProps<TData>) => (
  <div className={styles.titleContainer}>
    <strong className={styles.title}>{title}</strong>
    {breadcrumb && (
      <Link className={styles.link} to={breadcrumb.to} onClick={breadcrumb.onClick} id="skipNavTarget">
        {breadcrumb.label}
      </Link>
    )}
  </div>
);

export default BundleUpchargeTableTitle;
